module.exports = __webpack_public_path__ + "media/images/icons/flags/SO-ab65ba445020ae2d86b122b5908fec84.svg";